import { useCallback, useEffect } from 'react'
import Geocode from 'react-geocode'

import formatGoogleLatLonResponse from './utils/formatGoogleLatLonResponse'
import formatGoogleAddressResponse from './utils/formatGoogleAddressResponse'
import { GoogleAddressResponse } from './types'

type CoordinatesParams = {
  lat: number
  lng: number
}

export function useGoogleGeolocation() {
  const loadGeocodeSettings = useCallback(() => {
    Geocode.setApiKey('AIzaSyAkPAwCTMLlZaL-5SzsPOh3tqKPWoS6TOc')
    Geocode.setLanguage('pt-BR')
    Geocode.setRegion('br')
    Geocode.setLocationType('ROOFTOP')
  }, [])

  const getGoogleAddressByIncompleteAddress = useCallback(
    async (address: string): Promise<GoogleAddressResponse | any> => {
      try {
        const response = await Geocode?.fromAddress(address)
        const result = response?.results[0]
        const formatedResult = formatGoogleAddressResponse(result)
        return formatedResult
      } catch (error) {
        console.log('error', error)
      }
    },
    []
  )

  const getGoogleAddressByLatLon = useCallback(
    async ({ lat, lng }: CoordinatesParams): Promise<GoogleAddressResponse | void> => {
      try {
        const response = await Geocode?.fromLatLng(String(lat), String(lng))
        const result = response?.results[0]
        const formatedResult = await formatGoogleLatLonResponse(result)
        return formatedResult
      } catch (error) {
        console.log('error', error)
      }
    },
    []
  )

  useEffect(() => {
    loadGeocodeSettings()
  }, [])

  return {
    getGoogleAddressByLatLon,
    getGoogleAddressByIncompleteAddress,
  }
}
